module.exports = __webpack_public_path__ + "static/media/img1-1.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/melon/nutricheck_foliar/B/img1-1.png
// module id = 1822
// module chunks = 3